// extracted by mini-css-extract-plugin
export var cartContainer = "_nq-4";
export var gray = "_nq-1";
export var itemContainer = "_nq-2";
export var itemDetails = "_nq-3";
export var strong = "_nq-0";